
// Check si on doit proposer un sondage pour continuer la vente
export function checkMustProposeSurveyToContinue(mvcapi, userPKID, posID) {
  return mvcapi.postCtl("survey/checkmustproposesurveytocontinue", {
    userPKID,
    posID
  });
}



